import type {FilterConfigurationLineItem} from "~/components/ottopilotDataViewer/filterConfiguration";

export function filterLineItemsEqual(
    left: FilterConfigurationLineItem,
    right: FilterConfigurationLineItem,
): boolean {
    if (left.columnId !== right.columnId || left.operation !== right.operation) {
        return false;
    }
    if ("values" in left && "values" in right) {
        return JSON.stringify(left.values) === JSON.stringify(right.values);
    }
    if ("value" in left && "value" in right) {
        return left.value === right.value;
    }
    return false;
}

export function isPreservedFilterLineItem(
    lineItem: FilterConfigurationLineItem,
    preservedLineItems: ReadonlyArray<FilterConfigurationLineItem>,
): boolean {
    return preservedLineItems.some((preserved) => filterLineItemsEqual(preserved, lineItem) === true);
}
